document.addEventListener("DOMContentLoaded", () => {
  const swatchList = document.querySelector(".swatch__list_pr");
  if (!swatchList) return;

  const form = swatchList.closest('form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  let hiddenIdInput = form.querySelector('input[type="hidden"][name="id"]');

  if (!hiddenIdInput) {
    hiddenIdInput = document.createElement("input");
    hiddenIdInput.type = "hidden";
    hiddenIdInput.name = "id";
    form.appendChild(hiddenIdInput);
  }

  const updateVariantId = () => {
    const selected = swatchList.querySelector("li.is-selected");
    if (!selected) return;

    const variantId = selected.getAttribute("data-variant-id");
    if (variantId) {
      hiddenIdInput.value = variantId;

      const url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);
      window.history.replaceState({}, "", url.toString());
    }
  };

  updateVariantId();

  swatchList.querySelectorAll("li").forEach(li => {
    li.addEventListener("click", () => {
      setTimeout(updateVariantId, 50);
    });
  });
});
